export const SERVER_ERRORS = {
  WORK_ORDER_ALREADY_EXISTS: "Work order already exists",
  ALERT_WORK_ORDER_DESCRIPTION_EXCEEDS_MAX_LENGTH:
    "Description exceeds max length",
  CANNOT_DISCARD_OVERRIDE_IN_THIS_STAGE:
    "Cannot discard override with this status",
  SET_GATEWAY_IN_CONTROL_FAILED: "Manager's override could not be turned off"
};

export const DEFAULT_ERROR =
  "An error occurred. Please try to complete your request again later";

export const getErrorMessage = error => {
  let errorMessage = "";
  if (error != null && error && error.body && error.body.code) {
    errorMessage =
      typeof SERVER_ERRORS[error.body.code] === "undefined"
        ? DEFAULT_ERROR
        : SERVER_ERRORS[error.body.code];
  }
  return errorMessage;
};
